module.exports = __webpack_public_path__ + "static/2-fd279ed205d8e96c3ae0861dec2bc991.jpg";